import type { CapiProductPage } from 'types/capi/pdp';

import Tracked from '~/components/Tracked';
import usePageData from '~/hooks/usePageData';
import useRegion from '~/hooks/useRegion';
import type { TrackedButtonClickName } from '~/services/gtm.client';

const RelatedCategories = () => {
  const product = usePageData<CapiProductPage>();
  const region = useRegion();

  if (region.code !== 'GB') return null;

  return (
    <div className="flex flex-col gap-10">
      <h2 className="text-title-sm">Discover related categories</h2>
      <div className="flex flex-col gap-4 lg:flex-row">
        {product.related_categories.map((category, i) => (
          <Tracked.ExternalLink
            name={category.text as TrackedButtonClickName}
            variant="transparent-black-border"
            href={category.path}
            className="flex w-full items-center justify-center rounded-lg border border-black px-4 py-2.5 text-base font-semibold hover:text-gray-600"
            key={`related-category-${i}`}
            pagePosition="Body"
          >
            {category.text}
          </Tracked.ExternalLink>
        ))}
      </div>
    </div>
  );
};

export default RelatedCategories;
